export default __webpack_public_path__ + "static/media/Kingstown.3e902377.jpg";